module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_life-46bb8fc96b00f0ae94be3dcaef5a1bbe.png";